import * as React from 'react';
import { StatusCards } from './card-groups';
import { OutstandingFees } from './OutstandingFees';

export const Dashboard: React.FC = () => {
  return (
    <div className="px-4 py-8 space-y-8">
      <h2 className="font-bold text-2xl">Home</h2>
      <StatusCards />
      <OutstandingFees />
    </div>
  );
};
Dashboard.displayName = 'Shipments.Dashboard';
